import { apiFetch } from '@/lib/api-client';
import {
  AlertResult,
  DashboardFilterState,
  DashboardOverviewResult,
  PipelineResult,
  SalesTrendResult,
} from '@/types/dashboard';

function buildQuery(filters?: DashboardFilterState): string {
  if (!filters) return '';
  const params = new URLSearchParams();
  if (filters.marketplace && filters.marketplace !== 'ALL') {
    params.append('marketplace', filters.marketplace);
  }
  if (filters.dateFrom) {
    params.append('dateFrom', filters.dateFrom);
  }
  if (filters.dateTo) {
    params.append('dateTo', filters.dateTo);
  }
  if (filters.periodId) {
    params.append('periodId', filters.periodId);
  }
  const str = params.toString();
  return str ? `?${str}` : '';
}

export async function getOverview(
  filters?: DashboardFilterState,
): Promise<DashboardOverviewResult> {
  const query = buildQuery(filters);
  return apiFetch<DashboardOverviewResult>(`/dashboard/overview${query}`);
}

export async function getSalesTrend(
  filters?: DashboardFilterState,
): Promise<SalesTrendResult> {
  const query = buildQuery(filters);
  return apiFetch<SalesTrendResult>(`/dashboard/sales-trend${query}`);
}

export async function getPipeline(
  marketplace?: string,
): Promise<PipelineResult> {
  const params = new URLSearchParams();
  if (marketplace && marketplace !== 'ALL') {
    params.append('marketplace', marketplace);
  }
  const str = params.toString();
  const query = str ? `?${str}` : '';
  return apiFetch<PipelineResult>(`/dashboard/pipeline${query}`);
}

export async function getAlerts(
  filters?: DashboardFilterState,
): Promise<AlertResult> {
  const query = buildQuery(filters);
  return apiFetch<AlertResult>(`/dashboard/alerts${query}`);
}

export async function getDashboardData(filters?: DashboardFilterState): Promise<{
  overview: DashboardOverviewResult;
  salesTrend: SalesTrendResult;
  pipeline: PipelineResult;
  alerts: AlertResult;
}> {
  const [overview, salesTrend, pipeline, alerts] = await Promise.all([
    getOverview(filters),
    getSalesTrend(filters),
    getPipeline(filters?.marketplace),
    getAlerts(filters),
  ]);

  return {
    overview,
    salesTrend,
    pipeline,
    alerts,
  };
}
